import { Currency } from '@uniswap/sdk'
import { TokenInfo } from '../types'

export function currencyId(currency: Currency | TokenInfo): string {
  if ((currency as TokenInfo).address) return (currency as TokenInfo).address
  return currency.name ?? 'INVALID'
}
